import React, { useState } from 'react';

const coursesData = [
  {
    id: 1,
    tag: 'Curso 1',
    title: 'Estudio integral de plantas medicinales: taxonomía, etnobotánica, fitoquímica y farmacología',
    institution: 'Universidad Veracruzana',
    duration: '(2 días, 12 horas)',
    schedule: [
      { day: 'Lunes 12 de Octubre', details: '8 horas (08:00 a 13:00 y 15:00 a 18:00)' },
      { day: 'Martes 13 de Octubre', details: '4 horas (Visita al jardín botánico)' },
    ],
    faculty: [
      {
        name: 'Dra. Feliza Ramón Farías',
        role: 'Taxonomía (6 horas)',
        isLead: true,
        hasBio: true,
        bioId: 'feliza',
      },
      {
        name: 'Dra. Leticia M. Cano Asseleith',
        role: 'Etnobotánica y farmacología (3 horas)',
        isLead: false,
      },
      {
        name: 'Dr. Oscar A. Sánchez Aguirre',
        role: 'Fitoquímica (3 horas)',
        isLead: false,
      },
    ],
  },
  {
    id: 2,
    tag: 'Curso 2',
    title: 'De la planta a la molécula: introducción a GC-MS y RMN en plantas aromáticas y medicinales',
    institution: 'Universidad Simón Bolívar / Universidad de Turín',
    duration: 'Jornada intensiva',
    schedule: [
      { day: 'Martes 13 de Octubre', details: 'Sesión teórico-práctica' },
    ],
    faculty: [
      {
        name: 'Dra. Sara Pekerar',
        role: 'Universidad Simón Bolívar, Caracas - Venezuela',
        isLead: true,
        hasBio: true,
        bioId: 'sara',
      },
      {
        name: 'Dr. Carlo Bicchi',
        role: 'Universidad de Turín',
        isLead: false,
      },
    ],
  },
];

const facultyBios = {
  feliza: {
    name: 'Dra. Feliza Ramón Farías',
    title: 'Bióloga · Doctora en Biotecnología de Plantas',
    highlights: [
      'Investigaciones en Botánica, Etnobotánica, Sistemática de plantas con flores, Biotecnología Vegetal y plantas medicinales.',
      'Responsable del Herbario CORU de la Facultad de Ciencias Biológicas y Agropecuarias durante 15 años.',
      'Dirección de más de 30 tesis de licenciatura, maestría y doctorado (UV, UNAM, INECOL, A.C. y Tecnológico de Costa Rica).',
      'Integrante del Grupo Regional de Apoyo a la Medicina Indígena Tradicional (GRAMIT) desde 1999.',
      'Coordinadora del Proyecto integral para el estudio, aprovechamiento y conservación de Croton draco (sangregado) desde 2007.',
      'Investigadora invitada en el Instituto de Ecología, A.C. (2016 - 2020).',
      'Investigadora independiente y jubilada de la Universidad Veracruzana.',
    ],
  },
  sara: {
    name: 'Dra. Sara Pekerar',
    title: 'Lic. en Química · Magíster en Química (IVIC)',
    highlights: [
      'Graduada en Licenciatura de Química por la Universidad Simón Bolívar (1978).',
      'Magíster en Química por el Instituto Venezolano de Investigaciones Científicas - IVIC (1986).',
      'Encargada del servicio de Resonancia Magnética Nuclear (RMN) del Centro de Química del IVIC (1987 - 2009).',
      'Docente del posgrado de Química del IVIC (1988 - 2004).',
      'Docente del Departamento de Química de la Universidad Simón Bolívar desde 2005.',
      'Instructora técnica en entrenamiento teórico y práctico en equipos de RMN para diversas universidades.',
      '36 publicaciones en revistas indexadas y 26 presentaciones en congresos nacionales e internacionales.',
    ],
  },
};

export default function PreCongressCourses() {
  const [selectedBio, setSelectedBio] = useState(null);

  const openBioModal = (bioId) => {
    setSelectedBio(facultyBios[bioId]);
  };

  const closeBioModal = () => {
    setSelectedBio(null);
  };

  return (
    <section id="precongreso" className="py-12 px-4 sm:px-6 lg:px-8 bg-slate-50 min-h-screen text-slate-800">
      <div className="max-w-6xl mx-auto">
        {/* Encabezado */}
        <div className="text-center mb-12">
          <span className="text-xs font-bold uppercase tracking-wider text-emerald-700 bg-emerald-100 px-3 py-1 rounded-full">
            Programa académico
          </span>
          <h2  className="font-bold">
            Cursos Pre-Congreso
          </h2>
          <p className="  max-w-2xl mx-auto text-base text-slate-600">
            Capacitaciones intensivas previas al inicio de las conferencias magistrales. Cupos limitados.
          </p>
        </div>

        {/* Tarjetas de Cursos */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
          {coursesData.map((course) => (
            <div
              key={course.id}
              className="flex flex-col justify-between bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow border border-slate-200 overflow-hidden"
            >
              <div className="p-6 sm:p-8">
                {/* Etiqueta e Institución */}
                <div className="flex items-center justify-between gap-2 mb-4">
                  <span className="text-xs font-semibold text-white bg-[#004270] px-3 py-1 rounded-md">
                    {course.tag}
                  </span>
                  <span className="text-xs font-medium text-emerald-700 bg-emerald-50 border border-emerald-200 px-2.5 py-0.5 rounded-md text-right">
                    {course.duration}
                  </span>
                </div>

                {/* Título */}
                <h3 className="  font-bold  text-lg text-[#004270]">
                  {course.title}
                </h3>

                {/* Fechas / Horarios */}
                <div className="bg-slate-50 rounded-xl p-4 mb-6 border border-slate-100 space-y-2">
                  <h4 className="text-xs font-semibold uppercase tracking-wider text-slate-500">
                    Cronograma y Horarios
                  </h4>
                  {course.schedule.map((item, idx) => (
                    <div key={idx} className="text-sm">
                      <span className="font-semibold text-slate-700">{item.day}: </span>
                      <span className="text-slate-600">{item.details}</span>
                    </div>
                  ))}
                </div>

                {/* Docentes */}
                <div>
                  <h4 className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-3">
                    Equipo Docente
                  </h4>
                  <ul className="space-y-3">
                    {course.faculty.map((teacher, index) => (
                      <li
                        key={index}
                        
                      >
                        <div>
                          <div className="flex items-center gap-2">
                            <span className="font-semibold text-slate-900 text-sm">
                              {teacher.name}
                            </span>
                 
                         
                          </div>
                          <p className="text-xs text-slate-500 mt-0.5">{teacher.role}</p>
                        </div>

                        {teacher.hasBio && (
                          <button
                            onClick={() => openBioModal(teacher.bioId)}
                            type="button"
                            className="text-xs font-semibold text-emerald-700 hover:text-emerald-800 underline decoration-dotted self-start sm:self-auto cursor-pointer"
                          >
                            Ver Resumen CV
                          </button>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Pie de tarjeta */}
              <div className="bg-slate-50 px-6 py-4 border-t border-slate-100 text-xs text-slate-500 flex justify-between items-center">
                <span>Aval: {course.institution}</span>
          
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal / Diálogo de Síntesis Curricular */}
      {selectedBio && (
        <div
          role="dialog"
          aria-modal="true"
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-xs"
        >
          <div className="relative bg-white rounded-2xl max-w-lg w-full p-6 sm:p-8 shadow-2xl overflow-y-auto max-h-[90vh]">
            {/* Botón cerrar */}
            <button
              onClick={closeBioModal}
              className="absolute top-4 right-4 text-slate-400 hover:text-slate-600 rounded-lg p-1 text-lg font-bold"
              aria-label="Cerrar modal"
            >
              ✕
            </button>

            {/* Cabecera del modal */}
            <div className="mb-6">
              <span className="text-xs font-semibold text-emerald-700 uppercase tracking-wider">
                Docente Principal
              </span>
              <h3 className="text-xl font-bold text-slate-900 mt-1">
                {selectedBio.name}
              </h3>
              <p className="text-sm text-slate-600 font-medium mt-1">
                {selectedBio.title}
              </p>
            </div>

            {/* Lista de logros / trayectoria */}
            <div className="space-y-3 mb-6">
              <h4 className="text-xs font-bold uppercase text-slate-400">Trayectoria y Síntesis:</h4>
              <ul className="space-y-2 text-sm text-slate-700">
                {selectedBio.highlights.map((point, i) => (
                  <li key={i} className="flex items-start gap-2 text-[#004270]">
                 
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Botón de acción */}
            <button
              onClick={closeBioModal}
              className="w-full py-2.5 bg-slate-900 hover:bg-slate-800 text-white text-sm font-semibold rounded-xl transition-colors"
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
    </section>
  );
}